import * as Yup from 'yup'
import {Formik, Form, Field} from 'formik'
import {KTSVG} from '../../../helpers'
import {postRequest} from '../../../../app/pages/Helpers/Requests'
import toast from 'react-hot-toast'

const validationSchema = Yup.object().shape({
  connectorId: Yup.string().required('Connector is required'),
  expiry_date: Yup.string().required('Expiry date is required'),
  ocpp_idTag: Yup.string().required('OCPP ID TAG is required'),
})

function ReserveNow({stationId, connectors}) {
  const initialValues = {
    connectorId: '',
    expiry_date: '',
    ocpp_idTag: '',
  }

  const handleSubmit = async (values, {resetForm}) => {
    try {
      const res = await postRequest('/ocpp/remote/reserve-now/' + stationId, {
        ...values,
        expiry_date: new Date(values.expiry_date),
      })
      if (res && res.data) {
        toast.success(res.data.message)
      }
    } catch (error) {
      console.log(error)
      toast.error(error.response.data.message)
    }
  }

  return (
    <div className='modal fade' tabIndex={-1} id='reserve_now'>
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-header bg-success'>
            <h5 className='modal-title text-white'>Reserve Connector</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-success ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {() => (
                <Form>
                  <div>
                    <div className='row'>
                      <div className='col-md-12 mt-3'>
                        <label className='form-label'>Select Connector</label>
                        <Field as='select' name='connectorId' className='form-control'>
                          <option value=' '>Select Connector</option>
                          {connectors.map((connector) => {
                            return (
                              <option value={connector.connector_ID}>
                                {connector.connector_ID} {connector?.connectorType?.name}
                              </option>
                            )
                          })}
                        </Field>
                      </div>
                      <div className='col-md-12 mt-3'>
                        <label className='form-label'>Expiry Date</label>
                        <Field type='date' name='expiry_date' className='form-control' />
                      </div>
                      <div className='col-md-12 mt-3'>
                        <label className='form-label'>OCPP Id Tag</label>
                        <Field name='ocpp_idTag' className='form-control' />
                      </div>
                    </div>
                    <div className='modal-footer mt-3'>
                      <button
                        type='button'
                        className='btn btn-light-danger'
                        data-bs-dismiss='modal'
                      >
                        Cancel
                      </button>
                      <button
                        type='submit'
                        className='btn btn-light-success'
                        data-bs-dismiss='modal'
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReserveNow
